import { FormCampaignProps } from '@/models/FormCampaignProps'
import { parseDate } from '@internationalized/date'

export const initialStateFormCampaignContext: FormCampaignProps = {
  loading: false,
  step: 0,
  sbuList: [],
  brandList: [],
  modelList: [],
  buyList: [],
  initialLoad: true,
  form: {
    id: 0,
    name: '',
    scope: 'SBU',
    sbuId: '',
    brandId: '',
    modelId: '',
    buy: '',
    amount: '',
    startDate: parseDate(new Date().toISOString().split('T')[0]),
    endDate: parseDate(new Date().toISOString().split('T')[0]),
    isInfinite: false,
    maxQuantity: '',
    active: false
  }
}
